import { useTranslation } from 'react-i18next';

import { Spinner } from '~/components/Spinner';

function PageLoader() {
  const { t } = useTranslation('label-perf');

  return (
    <div className="relative flex items-center justify-center">
      <Spinner size="md" />
      <div className="absolute top-full mt-lg w-[calc(100vw-40px)] text-center">
        <h2 className="mb-sm text-body-md font-semibold text-white">
          {t('loading.title')}
        </h2>
        <p className="text-subtle">{t('loading.subtitle')}</p>
      </div>
    </div>
  );
}

PageLoader.displayName = 'PageLoader';

export { PageLoader };
